import ApiERP from '@/core/conectores/ApiERP';
import { IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { IDTOTituloFinanceiro } from '@/models/DTO/Financeiro/TitulosFinanceiros/IDTOTituloFinanceiro';
import { ETipoTituloFinanceiro } from '@/models/Enumeradores/Financeiro/ETipoTituloFinanceiro';

/**
 * Serviço importação de registro financeiros
 * Fornece todas regras de negócios e lógicas relacionado a importação de registros de estoques.
 */
class ServicoImportacaoFinanceiro {
    endPoint = 'importacao-financeiro';

    apiERP = new ApiERP();

    public requisicaoSistema():void {
      this.apiERP = new ApiERP(true);
    }

    public async obterArquivoPadraoTitulosFinanceiros(): Promise<string> {
      const result: any = await this.apiERP.get(`${this.endPoint}/titulos-financeiros/arquivo-template`);
      return result.data;
    }

    public async lerArquivoTitulosFinanceiros(empresa: number, tipoTitulo: ETipoTituloFinanceiro, arquivo: any): Promise<IDTOTituloFinanceiro[]> {
      const data = new FormData();
      data.append('arquivo', arquivo);

      const result: any = await this.apiERP.upload(`${this.endPoint}/titulos-financeiros/ler-arquivo/${empresa}/tipo-titulo/${tipoTitulo}`, data);
      return result.data;
    }

    public async importarTitulosFinanceiros(empresa: number, titulos: IDTOTituloFinanceiro[]): Promise<IRetornoRequisicao> {
      const result: any = await this.apiERP.post(`${this.endPoint}/titulos-financeiros/importar/${empresa}`, titulos);
      return result.data;
    }
}
export default ServicoImportacaoFinanceiro;
